import React from 'react';
import ProxyDialogContent from '../termsModalContent/request/ProxyDialogContent';
import PharmacyAttestation from '../termsModalContent/request/PharmacyAttestation';
import AdultProxyAttestation from '../termsModalContent/request/AdultProxyAttestation';
import MinorProxyMedicalPharmacy from '../termsModalContent/request/MinorProxyMedicalPharmacy';
import { getAge } from "../../../helpers/dateTime";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import Terms from '../Terms';
import {
    RX_EPIC_REQUEST_MINOR_FALLBACK_TERMS, INITIATE_REQUEST_ACEEPT_GRANT_FALLBACK_TERMS
} from "../../../constants/textConstants";
import * as ProxyHelper from "../ProxyHelper";

class AcceptTerms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mounted: false,
            isAcceptTermsSelected: false,            
            validationError: ""
        };      

        this.acceptTermsSelected = this.acceptTermsSelected.bind(this);
        this.isMinor = false;
    }

    componentDidMount() {
        const { useOnboardingLayout, listOfSelectedProxyUsers } = this.props;
        let count = listOfSelectedProxyUsers?.length > 0
        logUI(`MBHWeb.UI.ProxyRequest.AcceptTerms.ComponentDidMount${ProxyHelper.getProxySuggestions(count)}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
    }

    isValid() {
        return this.isValidate();
    }

    isValidate() {
        return this.state.isAcceptTermsSelected;
    }

    acceptTermsSelected = (e) => {
        if (e.target && e.target.checked)
            this.setState({ isAcceptTermsSelected: true, validationError: "" });
        else
            this.setState({ isAcceptTermsSelected: false });
    }

    onGoNext(success) {
        if (success) { 
            const { healthRecordSelected, pharmacySelected, termsandconditions, useOnboardingLayout } = this.props;
            let termsList = {};
           
            if (this.isMinor) {
                if (healthRecordSelected || pharmacySelected) {
                    termsList["MinorChildProxy"] = termsandconditions ? ProxyHelper.sanitizeContent(termsandconditions) : RX_EPIC_REQUEST_MINOR_FALLBACK_TERMS;
                }
                //if (pharmacySelected) {
                //    termsList["PharmacyAttestation"] = PHARMACY_ATTESTATION_PROXY;
                //}
            } else {
                if (healthRecordSelected) {
                    termsList["AdultProxy"] = termsandconditions ? ProxyHelper.sanitizeContent(termsandconditions) : INITIATE_REQUEST_ACEEPT_GRANT_FALLBACK_TERMS;
                }
            }
            logUI(`MBHWeb.UI.ProxyRequest.AcceptTerms.Attestation${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath(), termsList);
            if (this.props.onSubmit) {
                this.props.onSubmit();
            }
        } else {
            const { isAcceptTermsSelected, validationError } = this.state;
            if (isAcceptTermsSelected && validationError !== "") {
                this.setState({ validationError: "" });
            }
            else if (validationError === "") {
                this.setState({ isAcceptTermsSelected: false, validationError: "Please accept terms." });
            }
        }        
    }

    onGoBack(success) {
        const { proxyRequestData } = this.props;
        if (this.props.onGoNext) {
            this.props.onGoNext(true, { ...proxyRequestData, documentSubmitted: false });
        }
    }

    render() {
        const { heading, para, info, style, proxyRequestData, healthRecordSelected, pharmacySelected, minorChildProxy, adultProxy, authorizationAdult, termsandconditions, isWaitingForTermsInfo, minorChildProxyMedicalAndPharmacyHeader, useOnboardingLayout } = this.props;
        this.isMinor = proxyRequestData && proxyRequestData.dob ? getAge(proxyRequestData.dob) < 18 : true;
        let links = [];
        let index = 0;
        const proxyDialogContent = <ProxyDialogContent header={adultProxy} termsandconditions={termsandconditions} />;
        //const adultDialogContent = <AdultProxyAttestation heading={authorizationAdult} termsandconditions={termsandconditions}/>;
        //const pharmacyDialogContent = <PharmacyAttestation termsandconditions={termsandconditions} />;
        const minorProxyMedicalPharmacy = <MinorProxyMedicalPharmacy header={minorChildProxy} termsandconditions={termsandconditions} />;

        if (this.isMinor) {

            //if both medical and pharmacy for a minor, show the combined Terms content (need to merge medical and pharmacy content into a single component)
            if (healthRecordSelected && pharmacySelected) {
                links.push({ index, headingText: "terms & conditions", modalComponent: minorProxyMedicalPharmacy });
                index++;
            }
            else if (healthRecordSelected) {
                links.push({ index, headingText: "terms & conditions", modalComponent: minorProxyMedicalPharmacy });
                index++;
            }
            else if (pharmacySelected) {
                links.push({ index, headingText: "terms & conditions", modalComponent: minorProxyMedicalPharmacy });
                index++;
            }
        }
        else //is not a minor
        {
            if ((healthRecordSelected && !this.isMinor) || (pharmacySelected && !this.isMinor)) {
                links.push({ index, headingText: "terms & conditions", modalComponent: proxyDialogContent });
                index++;
                //Since health record is disabled for adult, we are commented below code.
                //links.push({ index, headingText: authorizationAdult, modalComponent: adultDialogContent });
                //index++;
            }
        }

        return (
            <Terms links={links} isMinor={this.isMinor} showAgreeAndFinish={false} history={this.props.history} style={style} acceptTermsSelected={this.acceptTermsSelected} validationError={this.state.validationError} callback={this.props.submitNewProxyRequest} isWaitingForTermsInfo={isWaitingForTermsInfo} />);
    }
}


AcceptTerms.defaultProps = {
    heading: `Great! Once you read and agree to the terms you'll be good to go.`,
    para: "Follow the links below and read the information carefully.",
    info: "By checking the box, you have read and agree to the",
    minorChildProxy: "Terms & Conditions",
    minorChildProxyMedicalAndPharmacyHeader: "Terms & Conditions",
    adultProxy: "Terms & Conditions",
    authorizationAdult: "Authorization for Release of Medical Information to Adult Proxy"
};

export default AcceptTerms;